const workbookData = [[['', 'Category 1'], ['Item 1', 5], ['Item 2', 4], ['Item 3', 3], ['Item 4', 2], ['Item 5', 1]]];
export default workbookData;